import React from 'react';
import './Themes.scss';
import '../CategoriesPage/Category.scss';
import { themes } from '../../assets/constants/themes';
import {Link} from 'react-router-dom';
const AllModules = () => {
    return (
        <div className="themes">
            <div className="subcategory container-sm "><span className="disabled">Ketegories</span> <i className="material-icons disabled">keyboard_arrow_right</i> <span className="disabled">Kurslar</span>  <i className="material-icons disabled">keyboard_arrow_right</i><span className="disabled">Modullar</span> <i className="material-icons ">keyboard_arrow_right</i><span className="active">Mavzular</span></div>
            <div className="container-sm  categories-sec themes-body">
                <div className="bg-text">
                    Mavzular
                </div>
                <h3 >Mavzular</h3>
                <div className="themes-list">
                    {
                        themes.map((theme, i) => {
                            return <Link to="/categories/courses/modules/themes/lesson" className={theme.isActives ? 'active' : 'disabled'}>
                                <span className='list-number '>{i + 1}</span>
                                <span className='list-theme'> mavzu</span>
                                {theme.title}
                            </Link>
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default AllModules;
